import React from 'react';
import { Modal } from '../../design-system';
import { useSelector } from 'react-redux';
import { getLang } from 'shared/store/selectors/lang.selector';

export function ConfirmationPopupComponent({
  open = false,
  title,
  message,
  isLoading = false,
  onConfirm,
  onDismiss,
  confirmMessage,
  dismissMessage,
  confirmButtonStyle = 'danger',
}) {
  const lang = useSelector(getLang('CONFIRMATION_MODAL_DEFAULT'));
  const confirm = confirmMessage ?? lang.CONFIRM;
  const dismiss = dismissMessage ?? lang.DISMISS;

  return (
    <Modal
      title={title}
      open={open}
      onCancel={onDismiss}
      onSubmit={onConfirm}
      cancelText={dismiss}
      submitText={confirm}
      submitDanger={confirmButtonStyle === 'danger'}
      loading={isLoading}>
      <p>{message}</p>
    </Modal>
  );
}
